function isValid(link) {
  let site = window.location.host
  return link.includes(site)
}

function queryByPath(path) {
  return [...document.querySelectorAll(path)]
}
function getArticleLinks() {
  return queryByPath('.post-content > p > a').concat(queryByPath('.post-content > p > strong > a'))
}

function getTopxLinks() {
  return queryByPath('.post-body > .fragment > p > a')
}

function getLinks() {
  let links = [...getArticleLinks()].length > 0 ? [...getArticleLinks()] : [...getTopxLinks()]
  return links.filter(link => isValid(link.href))
}

function getLinkDescription(link) {
  if (undefined !== link.href) {
    let parts = link.href.split('/')
    return parts[parts.length - 1]
  }
  return ''
}

export function linksCounter() {
  return getLinks().length
}

export function linksDescription() {
  var description = ''
  getLinks().forEach(link => {
    description += getLinkDescription(link) + ';'
  })

  return description
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/postBodyLinks/postBodyLinksCounter.js